"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = (0, makeStyles_1.default)((theme) => ({
    menuBarWrapper: {
        borderBottom: '1px solid #e7e7e7',
        display: 'flex',
        alignItems: 'flex-end',
        backgroundColor: theme.palette.primary.main,
        top: 0,
        width: '100%',
        zIndex: 1100,
    },
    iconlink: {
        width: 62,
        height: 62,
        zIndex: 99,
        cursor: 'pointer',
        color: 'white',
        flex: '0 0 auto',
        padding: 8,
    },
    menuBarInnerWrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    menuContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        flex: '0 0 33px',
    },
}));
//# sourceMappingURL=menubar-styles.js.map